//import './../Css/main.scss';
import { SessionStorage } from './teaserSlider/sessionStorage';
import { TeaserSliderManager } from './teaserSlider/teaserSliderManager';

export const onlineWorld = (): void => {
  const rootEl: HTMLElement = document.querySelector('.ow-teaser');
  const teaserSliderManager: TeaserSliderManager = new TeaserSliderManager();

  console.log(rootEl);
  console.log(rootEl);
  let active = false;
  setTimeout((): void => {
    if (rootEl !== null) {
      active = true;
      if (!SessionStorage.getStorage()) {
        teaserSliderManager.bootstrap();
      } else {
        teaserSliderManager.onCall();
      }
    }
  }, 3000);
};

onlineWorld();
